import { render, staticRenderFns } from "./StockVouchers.html?vue&type=template&id=aa452afc&scoped=true&external"
import script from "./StockVouchers.js?vue&type=script&lang=js&external"
export * from "./StockVouchers.js?vue&type=script&lang=js&external"
import style0 from "./StockVouchers.vue?vue&type=style&index=0&id=aa452afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa452afc",
  null
  
)

export default component.exports